@if(show) {
<div class="fixed top-6 right-6 z-[9999]">
  <app-alert
    [title]="toastTitle"
    [message]="toastMessage"
    [type]="toastType"
    [duration]="4000"
    role="alert"
    aria-live="assertive"
  >
  </app-alert>
</div>
}

<div class="flex min-h-screen bg-white">

  <!-- ===== PANEL IZQUIERDO: Hero visual ===== -->
  <div class="w-1/2 hidden md:flex relative overflow-hidden bg-[#0F0F3D]">
    <!-- Fondo principal (gradiente azul oscuro) -->
    <img src="assets/images/fondo-main.svg" alt="" class="absolute inset-0 w-full h-full object-cover" />
    <!-- Capa overlay con textura -->
    <img src="assets/images/fondo 1.svg" alt="" class="absolute inset-0 w-full h-full object-cover mix-blend-screen opacity-100" />

    <!-- Contenido sobre el fondo -->
    <div class="relative z-10 flex flex-col justify-between h-full w-full px-6 py-8 lg:pl-20 lg:pr-12 lg:py-12">
      <!-- Logo ARDIA -->
      <div>
        <img src="assets/images/ardia.svg" alt="ARDIA" class="h-7 lg:h-10 brightness-0 invert" />
      </div>

      <!-- Texto hero -->
      <div class="flex-1 flex items-center">
        <h1 class="text-white text-3xl md:text-4xl lg:text-[3.2rem] xl:text-[3.5rem] font-extrabold leading-[1.15] tracking-tight" style="text-shadow: 0 1px 8px rgba(0,0,0,0.18);">
          La plataforma de<br>
          <span class="text-[#60A5FA]">Agentes<br>Inteligentes</span>,<br>
          conectada a los<br>
          datos de tu<br>
          empresa en<br>
          tiempo real.
        </h1>
      </div>

      <!-- Tagline inferior -->
      <div class="flex items-center gap-4 w-full">
        <div class="flex-1 h-px bg-white/30"></div>
        <p class="text-[11px] font-semibold uppercase tracking-[0.3em] text-white/80 whitespace-nowrap">Inteligencia artificial para empresas</p>
        <div class="flex-1 h-px bg-white/30"></div>
      </div>
    </div>
  </div>

  <!-- ===== PANEL DERECHO: Formulario ===== -->
  <div class="w-full md:w-1/2 flex items-center justify-center px-6 py-10">
    <div class="max-w-[420px] w-full">

      <!-- ==================== PASO 1: EMAIL ==================== -->
      @if(currentStep === RecoveryStep.EMAIL) {
      <div class="tab-content-animate">
        <p class="text-[16px] text-[#111827] mb-2">Recupera tu acceso</p>
        <h2 class="text-[28px] font-bold text-[#111827] mb-3">¿Olvidaste tu contraseña?</h2>
        <p class="text-[15px] text-[#6B7280] mb-8">Introduce tu correo y te enviaremos un enlace para restablecer tu contraseña.</p>

        <form
          [formGroup]="forgotPasswordForm"
          (ngSubmit)="requestPasswordReset()"
          class="flex flex-col gap-5"
          aria-labelledby="reset-form-heading"
        >
          <h3 id="reset-form-heading" class="sr-only">Formulario de recuperación de contraseña</h3>

          <div>
            <label for="email" class="block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280] mb-2">
              Correo electrónico
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              placeholder="nombre@empresa.com"
              class="w-full border border-[#E5E7EB] px-4 py-3.5 rounded-lg bg-[#F9FAFB] focus:outline-none focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]/30 text-[#111827] text-[14px] placeholder-[#9CA3AF] transition-colors"
              aria-required="true"
              formControlName="email"
              (input)="convertToLowercase($event)"
              style="text-transform: lowercase;"
              aria-describedby="email-error"
              autocomplete="email"
            />
            <div id="email-error" class="text-[var(--color-error-500)] text-xs mt-1.5" aria-live="polite">
              @if(forgotPasswordForm.controls['email'].invalid && forgotPasswordForm.controls['email'].touched) {
                Introduce un correo electrónico válido
              }
            </div>
          </div>

          <button
            type="submit"
            class="w-full bg-[var(--color-brand-400)] text-white rounded-xl h-[50px] cursor-pointer hover:bg-[var(--color-brand-500)] disabled:bg-[#D1D5DB] disabled:cursor-not-allowed flex items-center justify-center gap-2 text-[15px] font-semibold transition-colors shadow-sm"
            [disabled]="isLoading"
            aria-label="Enviar solicitud de recuperación"
          >
            @if(isLoading) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Enviando...</span>
            } @else {
              <span>Continuar</span>
              <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
            }
          </button>
        </form>

        <!-- Volver al inicio de sesión -->
        <div class="mt-8">
          <a routerLink="/" class="text-[14px] text-[var(--color-brand-400)] hover:underline font-semibold cursor-pointer flex items-center" aria-label="Volver al inicio de sesión">
            Volver al inicio de sesión
            <fa-icon [icon]="faChevronRight" class="text-sm ml-1"></fa-icon>
          </a>
        </div>
      </div>
      }

      <!-- ==================== PASO 2: CONFIRMACIÓN ==================== -->
      @if(currentStep === RecoveryStep.CONFIRMATION) {
      <div class="tab-content-animate">
        <div class="text-center">
          <!-- Icono email -->
          <div class="w-16 h-16 mx-auto mb-6 bg-[var(--color-brand-400)]/10 rounded-full flex items-center justify-center">
            <svg class="w-8 h-8 text-[var(--color-brand-400)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          </div>
          <h2 class="text-[24px] font-bold text-[#111827] mb-3">Revisa tu correo</h2>
          <p class="text-[15px] text-[#6B7280] mb-2">Hemos enviado un enlace de recuperación a:</p>
          <p class="text-[15px] font-semibold text-[#111827] mb-6">{{ recoveryEmail }}</p>
          <p class="text-[13px] text-[#9CA3AF] mb-6">Si no recibes el correo en unos minutos, revisa tu carpeta de spam.</p>
        </div>

        <button
          type="button"
          class="w-full bg-[var(--color-brand-400)] text-white rounded-xl h-[50px] cursor-pointer hover:bg-[var(--color-brand-500)] flex items-center justify-center gap-2 text-[15px] font-semibold transition-colors shadow-sm"
          (click)="currentStep = RecoveryStep.EMAIL"
          aria-label="Solicitar nuevo enlace"
        >
          <span>Solicitar nuevo enlace</span>
          <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
        </button>

        <!-- Volver al inicio de sesión -->
        <div class="mt-8">
          <a routerLink="/" class="text-[14px] text-[var(--color-brand-400)] hover:underline font-semibold cursor-pointer flex items-center" aria-label="Volver al inicio de sesión">
            Volver al inicio de sesión
            <fa-icon [icon]="faChevronRight" class="text-sm ml-1"></fa-icon>
          </a>
        </div>
      </div>
      }

      <!-- ==================== PASO 3: NUEVA CONTRASEÑA ==================== -->
      @if(currentStep === RecoveryStep.PASSWORD) {
      <div class="tab-content-animate">
        <p class="text-[16px] text-[#111827] mb-2">Último paso</p>
        <h2 class="text-[28px] font-bold text-[#111827] mb-3">Escribe tu nueva contraseña</h2>
        <p class="text-[15px] text-[#6B7280] mb-8">Elige una contraseña segura para proteger tu cuenta.</p>

        <form
          [formGroup]="passwordForm"
          (ngSubmit)="resetPassword()"
          class="flex flex-col gap-5"
          aria-labelledby="password-form-heading"
        >
          <h3 id="password-form-heading" class="sr-only">Establece tu nueva contraseña</h3>

          <div>
            <label for="password" class="block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280] mb-2">
              Nueva contraseña
            </label>
            <input
              id="password"
              name="password"
              type="password"
              required
              placeholder="Contraseña segura"
              class="w-full border border-[#E5E7EB] px-4 py-3.5 rounded-lg bg-[#F9FAFB] focus:outline-none focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]/30 text-[#111827] text-[14px] placeholder-[#9CA3AF] transition-colors"
              aria-required="true"
              formControlName="password"
              aria-describedby="password-error"
              autocomplete="new-password"
            />
            <div id="password-error" class="text-[var(--color-error-500)] text-xs mt-1.5" aria-live="polite">
              @if(passwordForm.controls['password'].invalid && passwordForm.controls['password'].touched) {
                @if(passwordForm.controls['password'].errors?.['required']) {
                  La contraseña es obligatoria
                }
              }
            </div>
          </div>

          @if (passwordForm.get('password')?.value) {
          <div class="space-y-2" aria-live="polite">
            <p class="text-xs font-medium text-[#6B7280]">Requisitos:</p>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().minLength"
                [class.bg-red-200]="!getPasswordRequirements().minLength">
                @if (getPasswordRequirements().minLength) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().minLength"
                [class.text-gray-400]="!getPasswordRequirements().minLength">Mínimo 8 caracteres</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasUppercase"
                [class.bg-red-200]="!getPasswordRequirements().hasUppercase">
                @if (getPasswordRequirements().hasUppercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasUppercase"
                [class.text-gray-400]="!getPasswordRequirements().hasUppercase">Una mayúscula (A-Z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasLowercase"
                [class.bg-red-200]="!getPasswordRequirements().hasLowercase">
                @if (getPasswordRequirements().hasLowercase) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasLowercase"
                [class.text-gray-400]="!getPasswordRequirements().hasLowercase">Una minúscula (a-z)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasNumber"
                [class.bg-red-200]="!getPasswordRequirements().hasNumber">
                @if (getPasswordRequirements().hasNumber) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasNumber"
                [class.text-gray-400]="!getPasswordRequirements().hasNumber">Un número (0-9)</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="w-4 h-4 rounded-full shrink-0 flex items-center justify-center"
                [class.bg-green-500]="getPasswordRequirements().hasSpecial"
                [class.bg-red-200]="!getPasswordRequirements().hasSpecial">
                @if (getPasswordRequirements().hasSpecial) { <span class="text-white text-[10px] leading-none">✓</span> }
              </span>
              <span class="text-xs" [class.text-green-600]="getPasswordRequirements().hasSpecial"
                [class.text-gray-400]="!getPasswordRequirements().hasSpecial">Un carácter especial (!&#64;#$%etc)</span>
            </div>
          </div>
          }

          <div>
            <label for="confirmPassword" class="block text-[11px] font-semibold uppercase tracking-wider text-[#6B7280] mb-2">
              Confirmar contraseña
            </label>
            <input
              id="confirmPassword"
              name="confirmPassword"
              type="password"
              required
              placeholder="Repite la contraseña"
              class="w-full border border-[#E5E7EB] px-4 py-3.5 rounded-lg bg-[#F9FAFB] focus:outline-none focus:border-[var(--color-brand-400)] focus:ring-1 focus:ring-[var(--color-brand-400)]/30 text-[#111827] text-[14px] placeholder-[#9CA3AF] transition-colors"
              aria-required="true"
              formControlName="confirmPassword"
              aria-describedby="confirm-password-error"
              autocomplete="new-password"
            />
            <div id="confirm-password-error" class="text-[var(--color-error-500)] text-xs mt-1.5" aria-live="polite">
              @if(passwordForm.controls['confirmPassword'].invalid && passwordForm.controls['confirmPassword'].touched) {
                @if(passwordForm.controls['confirmPassword'].errors?.['required']) {
                  La confirmación de contraseña es obligatoria
                } @else if(passwordForm.controls['confirmPassword'].errors?.['passwordMismatch']) {
                  Las contraseñas no coinciden
                }
              }
            </div>
          </div>

          <button
            type="submit"
            class="w-full bg-[var(--color-brand-400)] text-white rounded-xl h-[50px] cursor-pointer hover:bg-[var(--color-brand-500)] disabled:bg-[#D1D5DB] disabled:cursor-not-allowed flex items-center justify-center gap-2 text-[15px] font-semibold transition-colors shadow-sm"
            [disabled]="isLoading"
            aria-label="Restablecer contraseña"
          >
            @if(isLoading) {
              <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Actualizando...</span>
            } @else {
              <span>Actualizar contraseña</span>
              <fa-icon [icon]="faChevronRight" class="text-xs"></fa-icon>
            }
          </button>
        </form>

        <!-- Volver al inicio de sesión -->
        <div class="mt-8">
          <a routerLink="/" class="text-[14px] text-[var(--color-brand-400)] hover:underline font-semibold cursor-pointer flex items-center" aria-label="Volver al inicio de sesión">
            Volver al inicio de sesión
            <fa-icon [icon]="faChevronRight" class="text-sm ml-1"></fa-icon>
          </a>
        </div>
      </div>
      }

    </div>
  </div>
</div>
